import { render, staticRenderFns } from "./ShouhouDetail.vue?vue&type=template&id=bf277a1a&scoped=true"
import script from "./ShouhouDetail.vue?vue&type=script&lang=js"
export * from "./ShouhouDetail.vue?vue&type=script&lang=js"
import style0 from "./ShouhouDetail.vue?vue&type=style&index=0&id=bf277a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf277a1a",
  null
  
)

export default component.exports